import { Container, Row } from "reactstrap";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { BonusUi, RangeTitle } from "../../../constants";
import DefaultRangeSlider from "./defaultRangeSlider";
import MinMaxValue from "./minMaxValue";
import NegativeValue from "./negativeValue";
import Disabled from "./disabled";
import Prefix from "./prefix";
import FormateLabel from "./formateLabel";

const RangeSliderContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={RangeTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <DefaultRangeSlider />
          <MinMaxValue />
          <NegativeValue />
          <Disabled />
          <Prefix />
          <FormateLabel />
        </Row>
      </Container>
    </>
  );
};

export default RangeSliderContainer;
